import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/PropertyDetails.css";
import SimilarProperties from "./SimilarProperties";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function PropertyDetails() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [property, setProperty] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {

    fetch("https://urbanbrick.in.net/get-properties.php") 
      .then(res => res.json())
      .then(data => {

        const selected = data.find(
          (item) => String(item.id) === String(id) 
        );

        setProperty(selected);

      })
      .catch(err => console.log(err));

  }, [id]);

  if (!property) {

    return (
      <>
        <Navbar />

        <h2 style={{ padding: "20px" }}>
          Property not found
        </h2>

        <Footer />
      </>
    );

  }

  const nextImage = () => {

    setCurrentIndex((prev) =>
      (prev + 1) %
      property.images.length
    );

  };

  const prevImage = () => {

    setCurrentIndex((prev) =>
      prev === 0
        ? property.images.length - 1
        : prev - 1
    );

  };

  return (

<>
  
  <Navbar />

  <div style={{ padding: "30px" }}>

    <button
      className="back-btn"
      onClick={() => navigate(-1)}
    >
      ⬅ Back
    </button>

    <div className="property-details-container">

      <div className="property-image">

        <button className="details-arrow left" onClick={prevImage}>
          ❮
        </button>

        <img
          src={property.images?.[currentIndex]}
          alt=""
        />

        <button className="details-arrow right" onClick={nextImage}>
          ❯
        </button>

      </div>

      <div className="property-info">

        <h2>{property.listingType}</h2> 

        <p>
          <b>Location:</b>
          {property.location} 
        </p>

        <p>
          <b>Price:</b>
          ₹ {property.price}
        </p>

        <p>
          <b>Posted By:</b>
          {property.postedBy} 
        </p>

        <p>
          <b>Status:</b>
          {property.status} 
        </p>

        <button
          className="more-enquiry-btn"
          onClick={() => setShowForm(true)}
        >
          More Enquiries
        </button>

      </div>

    </div>

    {showForm && (

      <div className="popup-overlay">

        <div className="popup-form">

          <h3>Property Enquiry</h3>

          <img
            src={property.images?.[0]}
            alt=""
            className="popup-image"
          />

          <input type="text" value={property.listingType} readOnly />
          <input type="text" value={property.location} readOnly />

          <input type="text" placeholder="Your Name" id="name" />
          <input type="tel" placeholder="Your Phone" id="phone" />
          <textarea placeholder="Message" id="message" />

          <button
            onClick={() => {

              const name = document.getElementById("name").value;
              const phone = document.getElementById("phone").value;
              const message = document.getElementById("message").value;

              const text = `🏠 Property Enquiry
                   Type: ${property.listingType}
                   Location: ${property.location}
                   Name: ${name}
                   Phone: ${phone}
                  Message: ${message}`;

              const whatsappURL = `https://wa.me/918725065442?text=${encodeURIComponent(text)}`;

              window.open(whatsappURL, "_blank");

            }}
          >
            Submit
          </button>

          <button
            className="close-btn"
            onClick={() => setShowForm(false)}
          >
            ✖ Close
          </button>

        </div>

      </div>

    )}

    <SimilarProperties selectedProperty={property} />

  </div>

  <Footer />

</>

  );

}

export default PropertyDetails;